// Stads-landningssidor för Local SEO.
// Varje stad får en egen sida (t.ex. /jurist-stockholm) optimerad för "jurist [stad]"-sökningar.
// Lägg till en ny stad genom att lägga till ett nytt entry här.

export const CITY_PAGES = {
    stockholm: {
        slug: "stockholm",
        name: "Stockholm",
        nameLocative: "Stockholm",
        nameInflected: "Stockholm",
        seoTitle: "Jurist Stockholm — BM Juridik",
        seoDescription:
            "Söker du jurist i Stockholm? BM Juridik har kontor på Klarabergsviadukten med erfarna jurister inom familjerätt, brottmål, arvsrätt och fastighetsrätt.",
        address: "Waterfront Building, Klarabergsviadukten 63",
        postal: "111 64 Stockholm",
        addressLocality: "Stockholm",
        latitude: 59.3308,
        longitude: 18.0581,
        intro:
            "BM Juridik finns mitt i Stockholm — i ikoniska Waterfront Building intill Centralstationen. Vi företräder klienter i hela Stockholms län inom alla våra rättsområden: familjerätt, brottmål, arvsrätt, fastighetsrätt, arbetsrätt och mer.",
        nearbyAreas: [
            "Solna",
            "Sundbyberg",
            "Nacka",
            "Lidingö",
            "Tyresö",
            "Bromma",
            "Södermalm",
            "Vasastan",
            "Östermalm",
        ],
        courts: ["Stockholms tingsrätt", "Solna tingsrätt", "Södertörns tingsrätt", "Svea hovrätt"],
        usp: [
            "Centralt läge — 2 min från Centralstationen",
            "Erfarna jurister inom alla rättsområden",
            "Möjlighet till fysiska eller digitala möten",
            "Företräder i alla Stockholmsdomstolar",
        ],
    },

    goteborg: {
        slug: "goteborg",
        name: "Göteborg",
        nameLocative: "Göteborg",
        nameInflected: "Göteborg",
        seoTitle: "Jurist Göteborg — BM Juridik",
        seoDescription:
            "Söker du jurist i Göteborg? BM Juridik har kontor på Östra Hamngatan med erfarna jurister inom familjerätt, brottmål, arvsrätt och fastighetsrätt.",
        address: "Östra Hamngatan 16",
        postal: "441 03 Göteborg",
        addressLocality: "Göteborg",
        latitude: 57.7089,
        longitude: 11.9746,
        intro:
            "BM Juridik finns mitt i Göteborgs centrum — på Östra Hamngatan, ett par minuter från Brunnsparken. Vi företräder klienter i Västra Götaland inom alla våra rättsområden, från Mölndal till Kungälv.",
        nearbyAreas: [
            "Mölndal",
            "Partille",
            "Kungälv",
            "Lerum",
            "Hisingen",
            "Linné",
            "Majorna",
            "Örgryte",
            "Härryda",
        ],
        courts: ["Göteborgs tingsrätt", "Mölndals tingsrätt", "Hovrätten för Västra Sverige"],
        usp: [
            "Centralt läge på Östra Hamngatan",
            "Företräder i alla Västra Götalands tingsrätter",
            "Erfaren juridik inom alla rättsområden",
            "Fysiska eller digitala möten",
        ],
    },

    malmo: {
        slug: "malmo",
        name: "Malmö",
        nameLocative: "Malmö",
        nameInflected: "Malmö",
        seoTitle: "Jurist Malmö — BM Juridik",
        seoDescription:
            "Söker du jurist i Malmö? BM Juridik har kontor på Studio Malmö med erfarna jurister inom familjerätt, brottmål, arvsrätt och fastighetsrätt.",
        address: "Studio Malmö, Nordenskiöldsgatan 24",
        postal: "211 19 Malmö",
        addressLocality: "Malmö",
        latitude: 55.6051,
        longitude: 12.9928,
        intro:
            "BM Juridik finns på Studio Malmö, en kreativ knutpunkt i centrala Malmö. Vi företräder klienter i Skåne inom alla våra rättsområden — från Lund till Trelleborg.",
        nearbyAreas: [
            "Lund",
            "Burlöv",
            "Trelleborg",
            "Vellinge",
            "Lomma",
            "Staffanstorp",
            "Limhamn",
            "Hyllie",
        ],
        courts: ["Malmö tingsrätt", "Lunds tingsrätt", "Hovrätten över Skåne och Blekinge"],
        usp: [
            "Centralt på Studio Malmö",
            "Företräder i hela Skåne",
            "Erfarenhet av öresundsregional juridik",
            "Fysiska eller digitala möten",
        ],
    },

    uppsala: {
        slug: "uppsala",
        name: "Uppsala",
        nameLocative: "Uppsala",
        nameInflected: "Uppsala",
        seoTitle: "Jurist Uppsala — BM Juridik",
        seoDescription:
            "Söker du jurist i Uppsala? BM Juridik har kontor i Rådhuset, Vaksalagatan, med erfarna jurister inom familjerätt, brottmål, arvsrätt och fastighetsrätt.",
        address: "Rådhuset, Vaksalagatan 2",
        postal: "753 20 Uppsala",
        addressLocality: "Uppsala",
        latitude: 59.8586,
        longitude: 17.6389,
        intro:
            "BM Juridik finns i Uppsalas hjärta — i historiska Rådhuset på Vaksalagatan. Vi företräder klienter i Uppsala län inom alla våra rättsområden.",
        nearbyAreas: [
            "Storvreta",
            "Knivsta",
            "Bålsta",
            "Tierp",
            "Enköping",
            "Fyrisån",
            "Sunnersta",
            "Eriksberg",
        ],
        courts: ["Uppsala tingsrätt", "Svea hovrätt"],
        usp: [
            "Centralt i historiska Rådhuset",
            "Företräder i Uppsala län",
            "Erfaren juridik inom alla rättsområden",
            "Fysiska eller digitala möten",
        ],
    },

    jonkoping: {
        slug: "jonkoping",
        name: "Jönköping",
        nameLocative: "Jönköping",
        nameInflected: "Jönköping",
        seoTitle: "Jurist Jönköping — BM Juridik",
        seoDescription:
            "Söker du jurist i Jönköping? BM Juridik har kontor på Vallgatan med erfarna jurister inom familjerätt, brottmål, arvsrätt och fastighetsrätt.",
        address: "Vallgatan 9",
        postal: "553 16 Jönköping",
        addressLocality: "Jönköping",
        latitude: 57.7826,
        longitude: 14.1618,
        intro:
            "BM Juridik finns mitt i Jönköping — på Vallgatan, ett stenkast från Hovrätten. Vi företräder klienter i Jönköpings län inom alla våra rättsområden.",
        nearbyAreas: [
            "Huskvarna",
            "Habo",
            "Bankeryd",
            "Vaggeryd",
            "Värnamo",
            "Nässjö",
            "Tranås",
            "Mullsjö",
        ],
        courts: ["Jönköpings tingsrätt", "Eksjö tingsrätt", "Göta hovrätt"],
        usp: [
            "Centralt på Vallgatan",
            "Nära Göta hovrätt",
            "Företräder i Jönköpings län",
            "Fysiska eller digitala möten",
        ],
    },

    herrljunga: {
        slug: "herrljunga",
        name: "Herrljunga",
        nameLocative: "Herrljunga",
        nameInflected: "Herrljunga",
        seoTitle: "Jurist Herrljunga — BM Juridik",
        seoDescription:
            "Söker du jurist i Herrljunga? BM Juridik har kontor på Åsbogärde med erfarna jurister inom familjerätt, brottmål och fastighetsrätt.",
        address: "Åsbogärde 2",
        postal: "524 93 Herrljunga",
        addressLocality: "Herrljunga",
        latitude: 58.0772,
        longitude: 13.0269,
        intro:
            "BM Juridik finns i Herrljunga — vårt lokala fäste i Västergötland. Vi företräder klienter inom hela regionen, från Vårgårda till Borås, inom alla våra rättsområden.",
        nearbyAreas: [
            "Vårgårda",
            "Alingsås",
            "Borås",
            "Falköping",
            "Floby",
            "Ljung",
            "Ulricehamn",
        ],
        courts: ["Borås tingsrätt", "Skaraborgs tingsrätt", "Hovrätten för Västra Sverige"],
        usp: [
            "Lokalt etablerade i Herrljunga",
            "Företräder i hela Västergötland",
            "Personlig service med lokal närvaro",
            "Fysiska eller digitala möten",
        ],
    },
};

export const CITY_LIST = Object.values(CITY_PAGES);
